import { render, staticRenderFns } from "./DriverCreate.vue?vue&type=template&id=519b3ebf&scoped=true&"
import script from "./DriverCreate.vue?vue&type=script&lang=js&"
export * from "./DriverCreate.vue?vue&type=script&lang=js&"
import style0 from "./DriverCreate.vue?vue&type=style&index=0&id=519b3ebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b3ebf",
  null
  
)

export default component.exports